// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current-plan-badge[data-v-e37caa96] {\n  border: 2px solid;\n  padding: 5px;\n}\n.collapsed .when-open[data-v-e37caa96],\n.not-collapsed .when-closed[data-v-e37caa96] {\n  display: none;\n}\n.pending-change-badge[data-v-e37caa96] {\n  padding: 8px;\n}", ""]);
// Exports
module.exports = exports;
